import { FC, Fragment } from "react"
import { Link } from "react-router-dom";

interface DataItemProps {
    text: string;
    url?: string;
}
interface AdminBreadcrumbProps {
    data: DataItemProps[]
}
const AdminBreadcrumb: FC<AdminBreadcrumbProps> = ({ data }) => {
    return <div className="mb-6">
        <nav className="text-sm text-gray-500 mb-2">
            <ol className="flex items-center space-x-2">
                {
                    data.map((item, i) => <Fragment>
                        {item.url ? <li>
                            <Link to={item.url} className="hover:text-blue-600 hover:underline">
                                {item.text}
                            </Link>
                        </li> : <li className="text-gray-700 font-semibold">{item.text}</li>}
                        {i < data.length - 1 ? <li><span>/</span></li> : null}
                    </Fragment>)
                }
            </ol>
        </nav>
    </div>
}

export default AdminBreadcrumb;